module.exports = __webpack_public_path__ + "dd7360604912cf0bb7703702efa619c7.svg";


//////////////////
// WEBPACK FOOTER
// ./application/font/SourceSansPro-SemiBold.svg
// module id = 369
// module chunks = 0